import { createSelector } from '@opengov/compose-app/reselect';
import { ISavedView } from '@opengov/reporting-types';

import { savedViewSelector, SavedViewsStatus } from '../state';

export const selectSavedViewState = createSelector(savedViewSelector, (state) => state);

export const selectSavedViews = createSelector(savedViewSelector, (state): ISavedView[] => state.savedViews);

export const selectSavedViewCurrentId = createSelector(savedViewSelector, (state): string => state.selectedSavedViewId);

export const selectSavedViewIdFilter = createSelector(
  selectSavedViews,
  (savedViews) => (id) => savedViews.find((sv) => sv.id === id)
);

export const selectCurrentSavedView = createSelector(
  selectSavedViewIdFilter,
  selectSavedViewCurrentId,
  (svFilter, svCurrentId) => svFilter(svCurrentId)
);

const by = (attribute: keyof ISavedView) => (a: ISavedView, b: ISavedView) => {
  const aValue = a[attribute] ?? '';
  const bValue = b[attribute] ?? '';
  if (aValue < bValue) {
    return -1;
  }
  if (aValue > bValue) {
    return 1;
  }

  return 0;
};

export const selectSavedViewsSort = createSelector(
  selectSavedViews,
  (savedViews) => (attribute: keyof ISavedView) => savedViews.sort(by(attribute))
);

export const selectSavedViewsByReportIdSortedByTitle = createSelector(
  selectSavedViews,
  (savedViews) => (id) => savedViews.filter((sv) => sv.reportId === id).sort(by('title'))
);

export const areSavedViewsLoading = createSelector(
  savedViewSelector,
  (state) => state.savedViewsStatus === SavedViewsStatus.Loading
);

export const previewsGenerating = createSelector(savedViewSelector, (state) => state.embedCreateQueue);

export const selectTotalSavedViews = createSelector(selectSavedViews, (savedViews) => savedViews.length);
